/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_Room_ManagementInputs */



/**
* | output |
* | --- |
* | "Room management" |
*
* @param {Air_Handler_Unit_Room_ManagementInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_room_management = /** @type {((inputs?: Air_Handler_Unit_Room_ManagementInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Room_ManagementInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Room management")
	return /** @type {LocalizedString} */ ("Gestion des pièces")
});